import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Leaf, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { LOGO_URL } from "@/lib/brand";

export default function Register() {
  const { register } = useApp();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", phone: "", password: "", email: "" });
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      const payload = { name: form.name, phone: form.phone, password: form.password };
      if (form.email.trim()) payload.email = form.email.trim();
      await register(payload);
      toast.success("Account created! Welcome to LIVENEAT.");
      nav("/account");
    } catch (e) { setErr(formatApiError(e.response?.data?.detail) || "Registration failed"); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 py-12 leaf-pattern">
      <div className="w-full max-w-md bg-white rounded-[28px] soft-shadow p-8">
        <div className="flex flex-col items-center mb-6">
          <img src={LOGO_URL} alt="LIVENEAT logo" className="h-32 w-auto object-contain mb-3" />
          <h1 className="font-heading text-3xl text-forest">Create Account</h1>
          <p className="text-sm text-brown/70">Join the LIVENEAT wellness community</p>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div><Label className="text-sm">Full Name</Label><Input value={form.name} onChange={set("name")} required className="rounded-xl bg-sand" data-testid="reg-name" /></div>
          <div><Label className="text-sm">Mobile Number</Label><Input type="tel" value={form.phone} onChange={set("phone")} required className="rounded-xl bg-sand" data-testid="reg-phone" placeholder="10-digit mobile number" /></div>
          <div><Label className="text-sm">Password</Label><Input type="password" value={form.password} onChange={set("password")} required className="rounded-xl bg-sand" data-testid="reg-password" /></div>
          <div><Label className="text-sm">Email <span className="text-brown/50">(optional)</span></Label><Input type="email" value={form.email} onChange={set("email")} className="rounded-xl bg-sand" data-testid="reg-email" placeholder="you@example.com" /></div>
          {err && <p className="text-sm text-terracotta" data-testid="reg-error">{err}</p>}
          <Button type="submit" disabled={loading} className="w-full rounded-full h-12 bg-forest hover:bg-earth text-cream" data-testid="reg-submit">{loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Create Account"}</Button>
        </form>
        <p className="text-sm text-center text-brown/70 mt-5">Already have an account? <Link to="/login" className="text-forest font-500 underline">Sign in</Link></p>
      </div>
    </div>
  );
}
